import { useUpc } from '@nuxt-common/media-card-large/app/composables/useUpc';
import { toValue } from '@vueuse/core';
import { useProduct } from '~/modules/product/composables/useProduct';
import useSelectedMemberId from '~/modules/latchkey/composables/useSelectedMemberId';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';

/**
 * @param {import('@vueuse/core').MaybeRef<string | number>} upcId
 */
export const useUpcPreselectBasic = (upcId) => {
  const selectedMemberId = useSelectedMemberId();
  const { productId } = useProduct();
  const { isShopTheSetExpEnabled } = useFeatureEligibility();
  const { selectedUpcNumber } = useUpc(isShopTheSetExpEnabled ? selectedMemberId : productId);
  selectedUpcNumber.value = +toValue(upcId);
};
